import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Navigation from "./Navigation";
import OnboardingJoyride from "./OnboardingJoyride";
import SessionMonitor from "./SessionMonitor";
import AskJarvis from "./Chat/AskJarvis";
import { useOnboarding } from "../contexts/OnboardingContext";

const Layout: React.FC = () => {
  const {
    shouldShowOnboarding,
    completeOnboarding,
    hideOnboarding,
    showOnboarding,
  } = useOnboarding();

  const runTour = shouldShowOnboarding();

  return (
    <div className="bg-gray-50 overflow-x-hidden h-screen max-h-screen">
      <Header />
      <div className="flex overflow-x-hidden">
        <Navigation />
        <main className="flex-1 p-6 overflow-x-hidden h-[calc(100vh-88px)] max-h-screen">
          <Outlet />
        </main>
      </div>

      <OnboardingJoyride run={runTour} onFinish={completeOnboarding} />
      <SessionMonitor />
      <AskJarvis />
    </div>
  );
};

export default Layout;
